import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {UserStateService} from '@services/frontend/user-state.service';
import {Role} from '@models/user.interface';

/** Redirige les experts-comptables hors de l'espace entrepreneur. */
export const executiveSpaceGuard: CanActivateFn = () => {
  const user = inject(UserStateService).getUser()();
  if (user?.role === Role.ACCOUNTANT) {
    return inject(Router).createUrlTree(['/dashboard', 'expert', 'clients']);
  }
  return true;
};
